/**
 * Determine whether or not the substring "storeName" is included within "text".
 * It does so by stripping both values from any special characters prior to comparision.
 * @param {string} text - the full text to find the substring in
 * @param {string} storeName - the substring to compare the text with
 * @returns {boolean}
 */
export default function hasStoreName(text, storeName) {
    if (!text || !storeName) 
        return false;
    const cleanStoreName = storeName.replace(/[^A-Za-z0-9]/g, '');
    const cleanText = text.replace(/[^A-Za-z0-9]/g, '');
    if (cleanText.includes(cleanStoreName)) 
        return true;
    return false;
}